import React from "react";
import data from "../json/Allproducts/Editlatex1.json";
import Section1 from "../components/Allproducts/Section1";
import Section4 from "../components/Allproducts/Section4";
import Section3 from "../components/Allproducts/Section3";

const EditLatex = () => {
  return (
    <div className="w-full flex flex-col items-center  ruler">
      <Section1 data={data} />
      <Section3 data={data.Section5}/>
      <Section4 data={data.Section4}/>
     
    </div>
  );
};

export default EditLatex;
